import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import title from '../../../assets/img/svg/title.svg'
import { useMenuContext } from '../../../contexts/MenuContext'
import Globus from '../../Globus/Globus'
import { Button } from '../../UI/Button'
import Container from '../Container/Container'
import styles from './Promo.module.scss'

const Promo = () => {
	const { t } = useTranslation()
	const { open } = useMenuContext()
	const navigate = useNavigate()

	const [width, setWidth] = React.useState(window.innerWidth)
	const handleResize = () => {
		setWidth(window.innerWidth)
	}
	useEffect(() => {
		window.addEventListener('resize', handleResize, false)
	}, [])

	return (
		<div className={[styles.wrapper, open ? styles.menuOpen : ''].join(' ')}>
			<Container>
				<div className={styles.body}>
					<img src={title} className={styles.title} />
					<p className={`${styles.text}, ${styles.title_text}`}>
						{t('landing.promo.title')}
						{/* Первая в мире социальная сеть для людей, которые хотят не только стать успешнее, но и помочь другим. */}
					</p>
					<p className={styles.text}>
						{t('landing.promo.text')}
						{/* Первая в мире социальная сеть для людей, которые хотят не только стать успешнее, но и помочь другим. */}
					</p>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							alignItems: 'center',
							gap: '20px',
						}}
					>
						<Button
							text={t('landing.promo.btn1')}
							color='magenta'
							onClick={() => navigate('/registration')}
						/>
						<Button
							className={styles.button2}
							text={t('landing.promo.btn2')}
							color='cian'
							onClick={() => navigate('/registration')}
						/>
					</div>
				</div>
			</Container>
			{width >= 1150 && <Globus className={styles.globus} />}
		</div>
	)
}

export default Promo
